export const SET_SDK_CONNECTION = 'SDK/connection/set';
export const SET_READER_CONNECTION = 'READER/connection/set';
export const SET_SDK_REGISTERATION = 'SDK/registration/set';

export const SET_KEY_MODEL = 'KEY/model/set';
export const SET_KEY_MULTITASK = 'KEY/multitask/set';

export const SET_PAD_CONNECTION = 'PAD/connection/set';

export const SET_FACTORY_AVAILABLE = 'SDK/FactoryAvailable/set';
